import type { ReturnOld as ApiReturnOld } from "randmar-api-client";

export default class Return {
  returnNumber?: string;
  resellerId?: number;
  status?: string;
  invoiceNumber?: string;
  requestDate?: string;
  creditNumber?: string;
  contactName?: string;
  contactPhone?: string;
  contactEmail?: string;
  comments?: string;
  resellerName?: string;
  warehouseLocation?: string;
  randmarSKU?: string;
  mpn?: string;
  title?: string;
  category?: string;
  unitWeight?: string;
  upc?: string;
  manufacturerName?: string;
  productType?: string;
  masterCarton?: number;
  skidQuantity?: number;
  serialNumber?: boolean;
  transparencyCode?: boolean;
  autoUpdate?: boolean;
  createdBy?: string;
  returnNumber1?: string;
  randmarSKU1?: string;
  quantity?: number;
  serialNumbers?: string;
  reasonForReturn?: string;

  constructor(source?: ApiReturnOld) {
    if (source) {
      this.returnNumber = source.ReturnNumber ?? undefined;
      this.resellerId = source.ResellerId ? Number.parseInt(source.ResellerId, 10) : undefined;
      this.status = source.Status ?? undefined;
      this.invoiceNumber = source.InvoiceNumber ?? undefined;
      this.requestDate = source.RequestDate ?? undefined;
      this.creditNumber = source.CreditNumber ?? undefined;
      this.contactName = source.ContactName ?? undefined;
      this.contactPhone = source.ContactPhone ?? undefined;
      this.contactEmail = source.ContactEmail ?? undefined;
      this.comments = source.Comments ?? undefined;
      this.resellerName = source.ResellerName ?? undefined;
      this.warehouseLocation = source.WarehouseLocation ?? undefined;
      this.randmarSKU = source.RandmarSKU ?? undefined;
      this.quantity = source.Quantity ?? undefined;
      this.serialNumbers = source.SerialNumbers ?? undefined;
      this.reasonForReturn = source.ReasonForReturn ?? undefined;
    }
  }

  public static convertFrom(source: ApiReturnOld): Return {
    return new Return(source);
  }
}
